<script>
    import MainContainer from "./MainContainer.svelte"
    import firebase from "firebase/app"
    import "firebase/firestore"
    import { getContext } from 'svelte'
    import cronstrue from 'cronstrue'
    import * as cronjsMatcher from '@datasert/cronjs-matcher'
	import { afterUpdate } from 'svelte'

    const userRole = getContext("userRole")
    const tournamentTypes = getContext("tournamentTypes") ?? []


    let tournamentsSize = 0
    let tournaments = []
    firebase.firestore().collection("Tournaments")
                        .orderBy('stage', "asc") // avoid firestore query error
                        .where("stage", "!=", "")
                        .orderBy('startTime', "asc")
                        .onSnapshot(querySnapshot => {
        //console.log(`Received tournaments query snapshot of size ${querySnapshot.size}`)
        tournamentsSize = querySnapshot.size
        tournaments = querySnapshot.docs.map(tournament => {
            //console.debug("tournament", tournament.id, tournament.data())
            return {...tournament.data(), id: tournament.id}
        })
        schedule = [...schedule] // Update schedule 
    }, err => {
        console.log(`Encountered error: ${err}`)
        //alert(err)
    })


    let schedule = []
    firebase.firestore().collection("TournamentsSchedule")
                        .onSnapshot(querySnapshot => {
        schedule = querySnapshot.docs.map(item => {
            return {...item.data(), id: item.id}
        })
    }, err => {
        console.log(`Encountered error: ${err}`)
        //alert(err)
    })


    function nextRun(cronExpression) {
        try {
            const date = cronjsMatcher.getFutureMatches(cronExpression)[0]
            return date ? new Date(date).toLocaleString() : "Never"
        } catch (err) {
            return err.message
        }
    }


    function addScheduleItem() {
        const addTournamentType = document.getElementById("add-tournament-type").value
        const addTournamentExperiment = document.getElementById("add-tournament-experiment").value
        const addCronExpression = document.getElementById("add-cron-expression").value
		firebase.firestore().collection("TournamentsSchedule").add({
			type: addTournamentType,
            experiment: addTournamentExperiment,
			cronExpression: addCronExpression
		})
    }


    function deleteScheduleItem(id) {
        firebase.firestore().collection("TournamentsSchedule").doc(id).delete()
    }


    function sheduleDescription(cronExpression) {
        try {
            return cronstrue.toString(cronExpression)
        } catch(e) {
            return "Invalid expression"
        }
    }


    async function startQATournament(qa) {
        const startTime = firebase.firestore.Timestamp.now()
        const defaultMaxNumber = -1000000
        const type = document.getElementById(`qa${qa}-tournament-type`).value
        const experiment = document.getElementById(`qa${qa}-tournament-experiment`).value
	
        const collectionName = qa > 1 ? `QA${qa}Tournaments` : "QATournaments"
	    const maxNumberRef = await firebase.firestore().collection(collectionName)
                                                       .orderBy('number', 'desc')
                                                       .limit(1).get()
	    const maxDataRef = maxNumberRef.docs ? maxNumberRef.docs[0] : null
	    const number = (maxDataRef?.data().number ?? defaultMaxNumber ?? 0) + 1
		
        await firebase.firestore().collection(collectionName).add({
            type,
            stage: "Registration", // XXX hardcoded
            startTime,
            experiment,
            number
        })

        M.toast({html: `QA${qa} Tournament started!`})
    }


	afterUpdate(async () => {
        let elems = document.querySelectorAll('.collapsible');
        let instances = M.Collapsible.init(elems);

		elems = document.querySelectorAll('.modal')
        instances = M.Modal.init(elems, {
            onOpenEnd: () => document.getElementById("add-cron-expression").focus()
        })

        elems = document.querySelectorAll('select');
        instances = M.FormSelect.init(elems)       
	})

</script>


<MainContainer>
    <h4>Active tournaments ({tournamentsSize})</h4>

    <table class="highlight" >
        <thead>
            <tr>
                <th>Number</th>
                <th>Start time</th>
                <th>Stage</th>
                <th>Type</th>
                <th>Experiment</th>
            </tr>
        </thead>
    
        <tbody>
            {#each tournaments as tournament}
                <tr class="tournament-row-{tournament.stage}">
                    <td class="tournament-number">{tournament.number}</td>
                    <td class="tournament-starttime">{tournament.startTime.toDate().toLocaleString()}</td>
                    <td class="tournament-stage">{tournament.stage}</td>
                    <td class="tournament-type">{tournament.type}</td>
                    <td class="tournament-experiment">{tournament.experiment ?? ""}</td>
                </tr>
            {/each}
        </tbody>
    </table>

    <div class="section-container">
        {#if userRole == "Writer"}
            <a class="btn-floating waves-effect waves-light right modal-trigger" href="#modal-add-schedule-item">
                <i class="large material-icons">add</i>
            </a>
        {/if}
        <h4>Schedule</h4>
        <p>
            The scheduler tries to start tournaments once per hour. So, scheduling "every 5 minutes" is the same as "every hour". 
        </p>
        <ul class="collapsible">
            <li>
                <div class="collapsible-header teal-text"><i class="material-icons">live_help</i>Some cron examples...</div>
                <div class="collapsible-body">
                    <ul>
                        <li><pre>0 13 * * ?         => every day at 1 PM.</pre></li>
                        <li><pre>0 22 ? * 6L        => last Friday of every month at 10 PM.</pre></li>
                        <li><pre>0 10 ? * MON-FRI   => Monday through Friday at 10 AM.</pre></li>
                        <li><pre>0 20 * * ? 2030    => every day at 8 PM during the year 2030.</pre></li>
                    </ul>            
                </div>
            </li>
        </ul>
        <table class="highlight" >
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Experiment</th>
                    <th>Next run</th>
                    <th>Description (UTC)</th>
                    <th>Cron expression</th>
                    <th></th>
                </tr>
            </thead>
        
            <tbody>
                {#each schedule as item}
                    <tr>
                        <td class="schedule-type">{item.type}</td>
                        <td class="schedule-experiment">{item.experiment ?? ""}</td>
                        <td class="schedule-nextrun">{nextRun(item.cronExpression)}</td>
                        <td class="schedule-description">{sheduleDescription(item.cronExpression)}</td>
                        <td class="schedule-cronexpression">{item.cronExpression}</td>
                        <td>
                            {#if userRole == "Writer"}
                                <div on:click={event => { event.stopPropagation(); deleteScheduleItem(item.id) }}>
                                    <i class="material-icons delete-icon">close</i>
                                </div>
                            {/if}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>

    <!-- Modal Structure -->
    <div id="modal-add-schedule-item" class="modal">
        <div class="modal-content">
            <h5>Add schedule item</h5>
            <div><pre>  </pre></div>
            <form>
                <div class="input-field">
                    <select id="add-tournament-type">
                        {#each tournamentTypes as type}
                            <option value="{type}">{type}</option>
                        {/each}
                    </select>
                    <label for="add-tournament-type">Type:</label>
                </div>
                <div class="input-field">
                    <input id="add-tournament-experiment" class="validate" type="text"/>
                    <label for="add-tournament-experiment">Experiment:</label>
                </div>
                <div class="input-field">
                    <input id="add-cron-expression" class="validate" type="text"/>
                    <label for="add-cron-expression">Cron exppression:</label>
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="modal-close waves-effect waves btn" on:click={addScheduleItem}>Add</a>
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="modal-close waves-effect waves btn-flat">Cancel</a>
        </div>
    </div>
    

    <div class="section-container">
        <h4>Debug</h4>

        <button class="btn waves-effect waves" title="Start QA Tournament" on:click={() => startQATournament(1)}>
            Start QA Tournament <i class="material-icons right">view_headline</i>
        </button>
        <form class="qa-tournament-form">
            <div class="input-field">
                <select id="qa1-tournament-type">
                    {#each tournamentTypes as type}
                        <option value="{type}">{type}</option>
                    {/each}
                </select>
            </div>
            <div class="input-field">
                <input id="qa1-tournament-experiment" class="validate" type="text"/>
                <label for="qa1-tournament-experiment">Experiment:</label>
            </div>
        </form>

        <button class="btn waves-effect waves" title="Start QA2 Tournament" on:click={() => startQATournament(2)}>
            Start QA2 Tournament <i class="material-icons right">view_headline</i>
        </button>
        <form class="qa-tournament-form">
            <div class="input-field">
                <select id="qa2-tournament-type">
                    {#each tournamentTypes as type}
                        <option value="{type}">{type}</option>
                    {/each}
                </select>
            </div>
            <div class="input-field">
                <input id="qa2-tournament-experiment" class="validate" type="text"/>
                <label for="qa2-tournament-experiment">Experiment:</label>
            </div>
        </form>
    </div>

</MainContainer>


<style>
    .tournament-number {
        width: 15%;
        user-select: none;
    }
    .schedule-experiment, .schedule-description {
        color: grey;
        font-style: italic;
    }
    .section-container {
        margin-top: 50px;
    }
    .delete-icon {
        color: grey;
        user-select: none;
    }
    .delete-icon:hover {
        color: red;
    }
    .tournament-row-Rewarding {
        color: lightgrey;
    }
    .qa-tournament-form {
        margin-bottom: 40px;
    }
</style>